import React from 'react';
import cn from 'classnames';

import { getEnumStringValue, RelatedContent_BorderMap } from 'js/utils/enum-string-maps';

import EmptyList from 'components/empty-list/EmptyList';
import Link from 'components/link/Link';
import Heading from 'components/heading/Heading';
import AutoGrid from 'components/auto-grid/AutoGrid';

import { IRelatedContent, RelatedContent_Border } from 'source/NFR.types';

interface RelatedContentProps extends IRelatedContent {
  isGrid?: boolean;
  itemMinWidth?: number;
}

const RelatedContent: React.FC<React.PropsWithChildren<RelatedContentProps>> = ({
  children,
  emptyList,
  link,
  onPageEditing,
  title,
  border = RelatedContent_Border.Bottom,
  isGrid,
  itemMinWidth
}) => {
  return (
    <div className={cn('related-content', { 'related-content--is-grid': isGrid })}>
      {title && (
        <Heading className="related-content--title" onPageEditing={onPageEditing?.title}>
          {title}
        </Heading>
      )}
      {React.Children.count(children) > 0 ? (
        <AutoGrid isList={!isGrid} minWidth={itemMinWidth}>
          {AutoGridItem =>
            React.Children.map(children, child => (
              <AutoGridItem
                className={cn(
                  null,
                  { 'related-content__item': !isGrid },
                  getEnumStringValue(RelatedContent_BorderMap, border)
                )}
              >
                {child}
              </AutoGridItem>
            ))
          }
        </AutoGrid>
      ) : (
        <EmptyList {...emptyList} />
      )}

      {link && (
        <div className="related-content--link">
          <Link
            className="related-content--link-inner"
            theme={isGrid ? ['secondary', 'large'] : ['secondary']}
            useButtonStyles
            {...link}
          />
        </div>
      )}
    </div>
  );
};

RelatedContent.displayName = 'RelatedContent';

export default RelatedContent;
